import Lenis from 'lenis'

const DESKTOP_BREAKPOINT = '(min-width: 992px)'
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

export default defineNuxtPlugin((nuxtApp) => {
	if (import.meta.server) return

	const desktopMedia = window.matchMedia(DESKTOP_BREAKPOINT)
	const reducedMotionMedia = window.matchMedia(REDUCED_MOTION_QUERY)

	let lenis: Lenis | null = null
	let rafId: number | null = null
	let bodyObserver: MutationObserver | null = null

	const canUseLenis = () => desktopMedia.matches && !reducedMotionMedia.matches
	const hasScrollLockOverlay = () => Boolean(document.body.querySelector('.layout-cover'))

	const raf = (time: number) => {
		lenis?.raf(time)
		rafId = window.requestAnimationFrame(raf)
	}

	const startLenis = () => {
		if (lenis || !canUseLenis()) return

		// Prevent CSS smooth scroll from conflicting with Lenis interpolation.
		document.documentElement.style.scrollBehavior = 'auto'

		lenis = new Lenis({
			autoRaf: false,
			smoothWheel: true,
			lerp: 0.2,
			wheelMultiplier: 1.1,
		})

		rafId = window.requestAnimationFrame(raf)
	}

	const stopLenis = () => {
		if (rafId !== null) {
			window.cancelAnimationFrame(rafId)
			rafId = null
		}

		lenis?.destroy()
		lenis = null
		document.documentElement.style.scrollBehavior = ''
	}

	const syncLenisState = () => {
		if (hasScrollLockOverlay()) {
			stopLenis()
			return
		}

		if (canUseLenis()) {
			startLenis()
			return
		}

		stopLenis()
	}

	const onMediaChange = () => {
		syncLenisState()
	}

	desktopMedia.addEventListener('change', onMediaChange)
	reducedMotionMedia.addEventListener('change', onMediaChange)
	bodyObserver = new MutationObserver(syncLenisState)
	bodyObserver.observe(document.body, {
		attributes: true,
		childList: true,
		subtree: true,
	})

	syncLenisState()

	nuxtApp.vueApp.onUnmount(() => {
		desktopMedia.removeEventListener('change', onMediaChange)
		reducedMotionMedia.removeEventListener('change', onMediaChange)
		bodyObserver?.disconnect()
		bodyObserver = null
		stopLenis()
	})
})
